<template>
    <div>
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" append-to-body
            :destroy-on-close="true" :before-close="cancel">
            <el-form class="formDiv" label-width="155px" ref="form" :model="form">
                <div style="width: 100%;display: flex;align-items: center;" :key="'report-project-type' + index"
                    v-for="(finalType, index) in form.finalReportTypes">
                    <div style="width: 98%;display: flex;flex-wrap: wrap;border: 1px dashed #d9d9d9;padding-top:20px;padding-right: 10px;border-bottom: none;"
                        :class="{ 'last-border': index === form.finalReportTypes.length - 1 }">
                        <el-form-item label="项目类型" :prop="'finalReportTypes.' + index + '.reportProjectType'"
                            :key="'project-type' + index" style="width: 50%!important;"
                            :rules="{ required: true, message: '请选择项目类型', trigger: 'change' }">
                            <el-select v-model="finalType.reportProjectType"
                                @change="value => handleProjectTypeChange(value, finalType,index)" placeholder="请选择项目类型"
                                filterable style="width: 100%;">
                                <el-option v-for="item in filteredTypeOptions(finalType)" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="具体类型" :prop="'finalReportTypes.' + index + '.concreteType'"
                            v-if="['NGS', 'LC'].includes(finalType.reportProjectType)" :key="'concrete-type1' + index"
                            style="width: 50%!important;"
                            :rules="{ required: true, message: '请选择具体类型', trigger: 'change' }">
                            <el-select v-model="finalType.concreteType" placeholder="请选择具体类型" filterable
                                style="width: 100%;" @change="value => handleConcreteTypeChange(value, finalType)">
                                <el-option v-for="item in concreteTypeOptions(finalType)" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="具体类型" v-if="!['NGS', 'LC'].includes(finalType.reportProjectType)"
                            :key="'concrete-type2' + index" style="width: 50%!important;">
                            <el-input v-model="NA" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="报告名称" :prop="'finalReportTypes.' + index + '.reportName'"
                            style="width: 50%!important;"
                            :rules="{ required: true, message: '请输入报告名称', trigger: 'change' }">
                            <el-input placeholder="请输入内容" v-model="finalType.reportName"></el-input>
                        </el-form-item>
                        <!-- 数据量 -->
                        <el-form-item label="数据量" :prop="'finalReportTypes.' + index + '.dataVolume'"
                            :key="'dataVolume1' + index" style="width: 50%!important;"
                            v-if="!['LC_MS'].includes(finalType.reportProjectType)"
                            :rules="[{ required: true, message: '请输入数据量', trigger: 'change' },
                            { validator: (rule, value, callback) => validateDataVolume(rule, value, callback, finalType.reportProjectType), trigger: 'change' }]">
                            <el-input placeholder="请输入内容" v-model="finalType.dataVolume"></el-input>
                        </el-form-item>
                        <el-form-item label="数据量" v-if="['LC_MS'].includes(finalType.reportProjectType)"
                            :key="'dataVolume2' + index" style="width: 50%!important;">
                            <el-input v-model="NA" disabled></el-input>
                        </el-form-item>
                    </div>
 
                    <div style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDeleteData(index)"
                            style="margin-bottom: 2px;"></el-button>
                        <el-button size="mini" icon="el-icon-plus" type="success" style="margin: 1px 0 0;"
                            v-if="index === form.finalReportTypes.length - 1" @click="handleAddData"></el-button>
                    </div>
                </div>
                <el-form-item label="客户单位" prop="client"
                    :rules="{ required: true, message: '请输入客户单位', trigger: 'change' }">
                    <el-input placeholder="请输入内容" v-model="form.client"></el-input>
                </el-form-item>
                <el-form-item label="客户名称" prop="projectContact"
                    :rules="{ required: true, message: '请输入客户名称', trigger: 'change' }">
                    <el-input placeholder="请输入内容" v-model="form.projectContact"></el-input>
                </el-form-item>
                <el-form-item label="报告后缀" prop="reportSuffix"
                    :rules="{ required: true, message: '请输入报告后缀', trigger: 'change' }">
                    <el-select v-model="form.reportSuffix" placeholder="请输入报告后缀" filterable style="width: 100%;">
                        <el-option v-for="item in nameOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报告公司" prop="reportCompany"
                    :rules="{ required: true, message: '请输入报告公司', trigger: 'change' }">
                    <el-select v-model="form.reportCompany" placeholder="请输入报告公司" filterable style="width: 100%;">
                        <el-option v-for="item in companyOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 合同号选择 -->
                <div style="width: 100%;display: flex;flex-wrap: wrap;" key="contract-no-mode">
                    <el-form-item label="合同号提供方式" prop="contractNoMode"
                        :rules="{ required: true, message: '请选择合同号提供方式', trigger: 'change' }">
                        <el-radio-group v-model="form.contractNoMode">
                            <el-radio label="random">随机生成</el-radio>
                            <el-radio label="manual">手动输入</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="合同号" prop="contractNo" key="manual-contract-no"
                        v-if="form.contractNoMode === 'manual'"
                        :rules="{ required: true, message: '请输入合同号', trigger: 'change' }">
                        <el-input placeholder="请输入合同号" v-model="form.contractNo"></el-input>
                    </el-form-item>
                    <el-form-item v-if="form.contractNoMode === 'random'" style="width: 48%!important;"
                        :key="'random-contract-no'" label="合同编号规则">
                        <span class="bold-text">
                            {{'BZB + 当天日期 + 随机编号,例:BZB2025101687862' }}</span>
                    </el-form-item>
                </div>
                <div style="width: 100%;display: flex;flex-wrap: wrap;" key="sample-name-mode">
                    <el-form-item label="样品名称" prop="sampleNameMode"
                        :rules="{ required: true, message: '请选择样品名称提供方式', trigger: 'change' }">
                        <el-radio-group v-model="form.sampleNameMode">
                            <el-radio label="random">随机生成</el-radio>
                            <el-radio label="assign">指定（上传样品表）</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- 指定时上传文件 -->
                    <el-form-item v-if="form.sampleNameMode === 'assign'" label="上传样品表" prop="fileName"
                        :key="'assign-file'" :rules="[{ required: true, message: '请上传文件', trigger: 'change' }]">
                        <div style="display: flex;align-items: center">
                            <el-input v-model="form.fileName" style="width: 82%!important;" readonly></el-input>
                            <el-upload class="upload-demo" style="width: 10%!important;" action="" :file-list="fileList"
                                :auto-upload="false" :on-change="onFileChange" :show-file-list="false">
                                <el-button size="small" style="margin-left: 10px;" icon="el-icon-plus"
                                    type="primary"></el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <!-- 随机生成时输入样品数量 -->
                    <el-form-item v-if="form.sampleNameMode === 'random'" label="样品数量" prop="numberOfSamples"
                        :key="'random-num'" :rules="[
                            { required: true, message: '请输入样品数量', trigger: 'change' },
                            { validator: validateSampleNum, trigger: 'change' }
                        ]">
                        <el-input placeholder="请输入内容" v-model="form.numberOfSamples"></el-input>
                    </el-form-item>
                    <el-form-item v-if="form.sampleNameMode === 'random'" :key="'random-num-n0'" label="样品随机生成规则">
                        <span class="bold-text">
                            {{ '随机两大写字母 + 顺序数字,例:AB01' }}</span>
                    </el-form-item>
                    <el-form-item v-if="form.sampleNameMode === 'random'" :key="'random-num-n1'" label="样品数量限制">
                        <span class="bold-text">{{ sampleNumRuleText }}</span>
                    </el-form-item>
                </div>
                <div style="width: 100%;display: flex;flex-wrap: wrap;">
                    <el-form-item label="添加公司结题报告章" prop="watermarkFlag"
                        :rules="{ required: true, message: '请选择是否添加水印', trigger: 'change' }">
                        <el-select v-model="form.watermarkFlag" placeholder="请选择是否添加水印" filterable style="width: 100%;">
                            <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <div v-if="form.sampleNameMode === 'assign'" style="width: 50%!important;padding-left: 125px;">
                        <div>
                            <span style="font-weight: bold;">eg.</span><a :href="`./file/example.txt`"
                                :underLine="false" download>example.txt</a>
                            <div class="bold-text">运行的样品名称只允许： 字母/数字/_-；不允许数字开头</div>
                        </div>
                    </div>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="title" @click="cancel">取消</el-button>
                <el-button size="small" type="success" class="title" @click="handle">提交</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { addReportGeneration } from "@/api/dilivery/report-generation";

export default {
    name: "CreateReportGeneration",
    props: {
        showDialog: {
            default: false
        }
    },
    data() {
        return {
            title: '生成结题报告',
            companyOptions: ['北京凌恩', '上海凌恩', '南京凌恩', '上海盈飞', '成都百麦斯特', '江苏凌帆', '南京微合','江苏普朗睿恩','陕西智享凌波','杭州永君'],
            nameOptions: ['结题报告', '测试报告'],
            TypeOptions: [
                { value: 'NGS', label: '扩增子',disabled:false },
                { value: 'BACTERIAL_COMPLETE_GENOME', label: '细菌完成图', disabled: true },
                { value: 'BACTERIAL_DRAFT_GENOME', label: '细菌扫描图', disabled: true },
                { value: 'META_GENOME', label: '宏基因组', disabled: true },
                { value: 'META_VIR_OME', label: '宏病毒组', disabled: true },
                { value: 'LC', label: '裸测', disabled: false },
                { value: 'RNA_SEQ', label: '真核转录组', disabled: true },
                { value: 'PROKARYOTIC_SEQ', label: '原核转录组', disabled: true },
                { value: 'FISH_EDNA', label: '鱼类eDNA', disabled: true },
                { value: 'LC_MS', label: '非靶向代谢组', disabled: true },
                { value: 'EDNA_PLANKTON', label: 'eDNA浮游', disabled: true },
                { value: 'META_TRANSCRIPT', label: '宏转录组', disabled: true },
                { value: 'META_GENOME_BINNING', label: '宏基因组binning', disabled: true },
                { value: 'POPULATION_SEQUENCING', label: '群体重测序', disabled: true },
                { value: 'INDIVIDUAL_SEQUENCING', label: '个体重测序', disabled: true },
            ],
            fileList: [],
            NA:'NA',
            flagOption: [
                { label: '是', value: true },
                { label: '否', value: false },
            ],
            form: {
                contractNoMode: 'random',
                sampleNameMode: 'random',
                file: null,
                fileName: '',
                client: '',
                reportCompany: '上海凌恩',
                projectContact: '',
                contractNo: '',
                watermarkFlag:true,
                finalReportTypes: [
                    {
                        reportProjectType: '',//项目类型
                        concreteType: '',//具体类型
                        dataVolume: '',//数据量
                        reportName:''//报告名称
                    },
                ],
                numberOfSamples: '',
                reportSuffix: '结题报告'
            }
        }
    },
    computed: {
        isOnlyPopulationSequencing() {
            const types = this.form.finalReportTypes.map(item => item.reportProjectType).filter(Boolean);
            return types.length > 0 && types.every(type => type === 'POPULATION_SEQUENCING');
        },
        isMetaGenomeBinning() {
            const types = this.form.finalReportTypes.map(item => item.reportProjectType).filter(Boolean);
            return types.length > 0 && types.every(type => type === 'META_GENOME_BINNING');
        },
        isOnlyIndividualSequencing() {
            const types = this.form.finalReportTypes.map(item => item.reportProjectType).filter(Boolean);
            return types.length > 0 && types.every(type => type === 'INDIVIDUAL_SEQUENCING');
        },
        sampleNumRuleText() {
            if (this.isOnlyPopulationSequencing) {
                return '群体重测序样品数量>=10 && <= 600';
            } else if (this.isMetaGenomeBinning) {
                return '宏基因组binning样品数量<=160';
            } else if (this.isOnlyIndividualSequencing) {
                return '个体重测序样品数量 <=1000';
            }
            return '单个报告样品数量<=300';
        }
    },
    methods: {
        handleDeleteData(index) {
            this.form.finalReportTypes.splice(index, 1)
            if (this.form.finalReportTypes.length === 0) {
                this.handleAddData()
            }
        },
        handleAddData() {
            this.form.finalReportTypes.push({
                reportProjectType: '',//项目类型
                concreteType: '',//具体类型
                dataVolume: '',//数据量
                reportName: ''//报告名称
            })
        },
        filteredTypeOptions(finalType) {
            // 获取已选的项目类型
            const selectedTypes = this.form.finalReportTypes.map(item => item.reportProjectType);
            return this.TypeOptions.filter(opt => {
                if (opt.disabled) {
                    // disabled为true，只能选一次
                    return !selectedTypes.includes(opt.value) || finalType.reportProjectType === opt.value;
                } else {
                    // disabled为false，可多次选
                    return true;
                }
            });
        },
        concreteTypeOptions(finalType) {
            try {
                switch (finalType.reportProjectType) {
                    case 'NGS':
                        return [
                            { label: '细菌二代扩增子', value: '16s-ngs' },
                            { label: '细菌三代扩增子', value: '16s-tgs' },
                            { label: '真菌二代扩增子', value: 'its-ngs' },
                            { label: '真菌三代扩增子', value: 'its-tgs' },
                            { label: '古菌扩增子', value: 'arch' }
                        ].filter(item => !this.concreteList(finalType.concreteType).includes(item.value));
                    case 'LC':
                        return [
                            { label: '宏基因组测序', value: '宏基因组测序' },
                            { label: '宏转录组测序', value: '宏转录组测序' },
                            { label: '宏病毒组测序', value: '宏病毒组测序' },
                            { label: '重测序', value: '重测序' },
                            { label: '真核转录组测序', value: '真核转录组测序' },
                            { label: '原核转录组测序', value: '原核转录组测序' },
                            { label: '全基因组甲基化测序', value: '全基因组甲基化测序' }
                        ].filter(item => !this.concreteList(finalType.concreteType).includes(item.value));
                    default:
                        return [];
                }
            } catch (error) {
                return []
            }
        },
        concreteList(concreteType) {
            return this.form.finalReportTypes
                .filter(item => item.concreteType !== concreteType && item.concreteType !== '')
                .map(item => item.concreteType);
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handleConcreteTypeChange(value, finalType) {
            if (finalType.reportProjectType !== 'LC') {
                return
            }
            switch (value) {
                case '宏基因组测序':
                    finalType.reportName = '宏基因组测序'
                    break;
                case '宏转录组测序':
                    finalType.reportName = '宏转录组测序'
                    break;
                case '宏病毒组测序':
                    finalType.reportName = '宏病毒组测序'
                    break;
                case '重测序':
                    finalType.reportName = '重测序'
                    break;
                case '真核转录组测序':
                    finalType.reportName = '真核转录组测序'
                    break;
                case '原核转录组测序':
                    finalType.reportName = '原核转录组测序'
                    break;
                case '全基因组甲基化测序':
                    finalType.reportName = '全基因组甲基化测序'
                    break;
                default:
                    break;
            }
        },
        handleProjectTypeChange(value, finalType,index) {
            finalType.concreteType = '';
            switch (value) {
                case 'NGS':
                    finalType.reportName = '微生物群落多样性测序'
                    break;
                case 'BACTERIAL_COMPLETE_GENOME':
                    finalType.reportName = '细菌基因组完成图'
                    break;
                case 'BACTERIAL_DRAFT_GENOME':
                    finalType.reportName = '细菌基因组扫描'
                    break;
                case 'META_GENOME':
                    finalType.reportName = '宏基因组测序及分析'
                    break;
                case 'META_VIR_OME':
                    finalType.reportName = '宏病毒组测序及分析'
                    break;
                case 'RNA_SEQ':
                    finalType.reportName = '真核转录组测序分析'
                    break;
                case 'PROKARYOTIC_SEQ':
                    finalType.reportName = '原核转录组测序分析'
                    break;
                case 'FISH_EDNA':
                    finalType.reportName = 'eDNA宏条形码（鱼类生态调研）'
                    break;
                case 'LC_MS':
                    finalType.reportName = '非靶向代谢组（LC-MS）质谱分析'
                    break
                case 'EDNA_PLANKTON':
                    finalType.reportName = 'eDNA宏条形码检测（浮游动植物）'
                    break
                case 'META_TRANSCRIPT':
                    finalType.reportName = '宏转录组测序及分析'
                    break
                case 'META_GENOME_BINNING':
                    finalType.reportName = '宏基因组测序及分析'
                    break 
                case 'POPULATION_SEQUENCING':
                    finalType.reportName = '群体重测序'
                    break
                case 'INDIVIDUAL_SEQUENCING':
                    finalType.reportName = '个体重测序'
                    break    
                default:
                    finalType.reportName = ''
                    this.$nextTick(() => {
                        if (this.$refs.form) {
                            this.$refs.form.clearValidate && this.$refs.form.clearValidate(`finalReportTypes.${index}.reportName`);
                        }
                    });
                    break;
            }
        },
        onRemove() {
            this.form.file = null
            this.form.fileName = ''
            this.fileList = []
        },
        onFileChange(file, fileList) {
            this.form.file = file
            this.form.fileName = file.name
            this.fileList = [file]
        },
        validateSampleNum(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入样品数量'))
                return
            }
            const num = parseInt(value)
            if (isNaN(num) || num <= 0) {
                callback(new Error('样品数量必须为正整数'))
                return
            }
            if (this.isOnlyPopulationSequencing) {
                if (num < 10 || num > 600) {
                    callback(new Error('群体重测序样品数量需在10到600之间'))
                    return
                }
            } else if (this.isOnlyIndividualSequencing) {
                if (num > 1000) {
                    callback(new Error('个体重测序样品数量不能超过1000'))
                    return
                }
            } else if (this.isMetaGenomeBinning) {
                if (num > 160) {
                    callback(new Error('宏基因组binning样品数量不能超过160'))
                    return
                }
            } else if (num > 300) {
                callback(new Error('单个报告样品数量不能超过300'))
                return
            }
            callback()
        },
        validateDataVolume(rule, value, callback, reportProjectType) {
            if (!value) {
                callback(new Error('请输入数据量'))
            } else if (isNaN(value) || Number(value) < 0) {
                callback(new Error('数据量必须大于等于0'))
            } else if (
                reportProjectType === 'NGS' &&
                (Number(value) < 10000 || Number(value) > 1000000)
            ) {
                callback(new Error('扩增子数据量需在1w到100w之间'))
            } else if (
                reportProjectType === 'FISH_EDNA' &&
                (Number(value) < 10000 || Number(value) > 1000000)
            ) {
                callback(new Error('鱼类eDNA数据量需在1w到100w之间'))
            } else if (
                reportProjectType === 'EDNA_PLANKTON' &&
                (Number(value) < 10000 || Number(value) > 1000000)
            ) {
                callback(new Error('eDNA浮游数据量需在1w到100w之间'))
            } else {
                callback()
            }
        },
        handle() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const formData = new FormData()
                    let form = { ...this.form }
                    if (form.contractNoMode === 'random') {
                        form.contractNo = ''
                    }
                    if (form.sampleNameMode !== 'random') {
                        form.numberOfSamples = ''
                        if (this.form.file) {
                            formData.append("file", this.form.file.raw);
                        }
                    }
                    const jsonStr = JSON.stringify(
                        Object.keys(form).reduce((acc, key) => {
                            if (!['file'].includes(key)) {
                                acc[key] = form[key];
                            }
                            return acc;
                        }, {})
                    );
                    const blob = new Blob([jsonStr], {
                        type: 'application/json'
                    });
                    formData.append("info", blob);

                    addReportGeneration(formData).then(res => {
                        if (res.code === 200) {
                            this.$messageUi.success('提交成功!')
                            this.$emit('submit', 'confirm')
                        }
                    }).catch(err => {
                        console.log(err);
                    })
                } else {
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.upload-demo {

    /*margin-top: 20px;*/
    width: 100% !important;
}
.last-border {
    border-bottom: 1px dashed #d9d9d9!important ;
    margin-bottom: 10px;
}
 :deep(.el-upload) {
    display: flex;
    gap: 20px;
    width: 100% !important;
}

@import "@/assets/css/mixins.scss";

.el-dialog-div {
    @include thin-scrollbar(8px, #888);
    max-height: 60vh;
    /* 你还可以在这个类里写其他样式 */
    background: #fff;
}

.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 45% !important;
}

.bold-text {
    /* font-weight: bold; */
    color: red;
    /* background-color: yellow; */
    font-size: 14px;
}
</style>
